/**
 * Persist CRM journey stage tab position per resident (demo).
 */

import LocalStorageService from '../services/storage/LocalStorageService';

const KEY = 'resident_crm_journey_positions';

function all() {
  const raw = LocalStorageService.get(KEY, {});
  return raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {};
}

/**
 * @param {string|number} residentId
 * @returns {{ stageTab: number, subStage7: string }}
 */
export function getJourneyPosition(residentId) {
  const row = all()[String(residentId)];
  if (!row || typeof row !== 'object') return { stageTab: 7, subStage7: '7B' };
  const stageTab = Number(row.stageTab);
  const subStage7 = typeof row.subStage7 === 'string' ? row.subStage7 : '7B';
  return {
    stageTab: Number.isFinite(stageTab) && stageTab >= 1 && stageTab <= 9 ? stageTab : 7,
    subStage7: /^7[A-E]$/i.test(subStage7) ? subStage7.toUpperCase() : '7B',
  };
}

/**
 * @param {string|number} residentId
 * @param {{ stageTab: number, subStage7: string }} pos
 */
export function saveJourneyPosition(residentId, pos) {
  const next = all();
  next[String(residentId)] = {
    stageTab: pos.stageTab,
    subStage7: pos.subStage7,
    updatedAt: new Date().toISOString(),
  };
  LocalStorageService.set(KEY, next);
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.debug('[residentJourneyStorage] saveJourneyPosition', { residentId: String(residentId), ...pos });
  }
}
